//import { useCallback } from 'react';
import ReactModal from 'react-modal';
import { Dashboard } from '../../interfaces/Dashboard';
import { useState } from 'react';
import Modal from 'react-modal';
//import api from '../../services/api';

interface DashboardCategoryItemProperties {
  dashboard: Dashboard;
}

export function DashboardCategoryItem({ dashboard }: DashboardCategoryItemProperties) {
  // const handleAccess = useCallback(() => {
  //   api.put(`/dashboards/${dashboard.urn}/access`);
  // }, [dashboard.urn]);

  const [showModal, setShowModal] = useState(false);

  const handleAccess = () => {
    const w = window.screen.width;
    const h = window.screen.height;
    //const windowFeatures = `left=${(w*0.05).toString()},top=${(h*0.05).toString()},width=${(w*0.9).toString()},height=${(h*0.9).toString()}`;
    const windowFeatures = `left=${(w*0.12).toString()},top=${(h*0.1).toString()},width=${(w*0.85).toString()},height=${(h*0.72).toString()}`;
    //const windowFeatures = "left=100,top=100,width=" + "1280" + ",height=720";
    window.open(dashboard.externalUrl, "salasituacao", windowFeatures)
  }

  const openModal = () => {
    setShowModal(true);
  }

  const closeModal = () => {
    setShowModal(false);
  }

  return (
//    <a href={dashboard.externalUrl} onClick={handleAccess} target="_blank" rel="noreferrer">
    // <a href={"#"} onClick={handleAccess}>
    //   <div className='categoria-item'>
    //     <h2 className='item-titulo item-caixa-categoria'>{dashboard.name}</h2>
    //     <div className='categoria-item-tags'>
    //       {dashboard.tags.map(tag => (
    //         <strong key={tag} className="categoria-item-tag">{tag}</strong>
    //       ))}
    //     </div>
    //   </div>
    // </a>
    // <>
    // <button onClick={openModal} className='categoria-item item-titulo'>{dashboard.name}</button>
    // <ReactModal isOpen={showModal} shouldCloseOnEsc={true} onRequestClose={closeModal}>
    //   <iframe src={dashboard.externalUrl} height={470} width={1110}></iframe>
    //   {/* <button onClick={closeModal}>X</button> */}
    // </ReactModal>
    // </>
    <button onClick={handleAccess} className='categoria-item item-titulo'>{dashboard.name}</button>
  );
};
